import { createSlice } from "@reduxjs/toolkit";

import { addWebSocketCases } from "../helpers/storeAction";
import {
  addNewCallsBlacklistsData,
  updateCallsBlacklist,
  fetchCallsBlacklistList,
  deleteCallsBlacklist,
} from "../thunks/callsBlacklistThunk";

import type { CallsBlackList } from "../../utils/types/callsBlacklist";

interface CallsBlacklistListState {
  callsBlackList: CallsBlackList[];
  loading: boolean;
  error: string | null;
  isDataFetched?: boolean;
}
const initialState: CallsBlacklistListState = {
  callsBlackList: [],
  loading: false,
  error: null,
  isDataFetched: false,
};

export const callsBlacklistListSlice = createSlice({
  name: "callsBlacklistList",
  initialState,
  reducers: {
    resetDataFetched: (state) => {
      state.isDataFetched = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCallsBlacklistList.pending, (state) => {
        state.loading = true;
        state.isDataFetched = true;
        state.error = null;
      })
      .addCase(fetchCallsBlacklistList.fulfilled, (state, action) => {
        state.callsBlackList = action?.payload || [];
        state.loading = false;
      })
      .addCase(fetchCallsBlacklistList.rejected, (state, action) => {
        state.error = action?.payload as string;
        state.isDataFetched = false;
        state.loading = false;
      });
    builder
      .addCase(updateCallsBlacklist.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateCallsBlacklist.fulfilled, (state, action) => {
        state.loading = false;
        state.callsBlackList = state.callsBlackList.map(
          (blacklist: CallsBlackList) => {
            if (
              blacklist?.blacklist_id === action?.payload?.data?.blacklist_id
            ) {
              return { ...blacklist, ...action?.payload?.data };
            }
            return blacklist;
          }
        );
      })
      .addCase(updateCallsBlacklist.rejected, (state) => {
        state.loading = false;
        state.error = "Unknown error… Please try again";
      });

    builder
      .addCase(deleteCallsBlacklist.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteCallsBlacklist.fulfilled, (state, action) => {
        state.loading = false;
        state.callsBlackList = state.callsBlackList.filter(
          (blacklist) =>
            blacklist.blacklist_id !== action?.payload?.blacklist_id
        );
      })
      .addCase(deleteCallsBlacklist.rejected, (state) => {
        state.loading = false;
        state.error = "Unknown error… Please try again";
      });

    builder
      .addCase(addNewCallsBlacklistsData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addNewCallsBlacklistsData.fulfilled, (state, action) => {
        state.loading = false;
        state.callsBlackList = [action.payload, ...state.callsBlackList];
      })
      .addCase(addNewCallsBlacklistsData.rejected, (state) => {
        state.loading = false;
        state.error = "Unknown error… Please try again";
      });
    addWebSocketCases(builder, "callsBlacklistList", "callsBlackList");
  },
});

export const { resetDataFetched } = callsBlacklistListSlice.actions;
export default callsBlacklistListSlice.reducer;
